import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect, Route, Switch } from "react-router";
import PropertyDetails from "../PropertyDetails";
import EjariContextWrapper from "@eres/ejari-core/contexts/EjariContext";
import PropertyEdit from "../PropertyEdit";
import { EjariPropertyLoader, TabuPropertyLoader } from "@eres/ejari-core/loaders/PropertyLoader";
import { EjariPropertyCoOccupants } from "../ManageCoOccupant";

interface Props extends RoutedViewProps<{ propertyTypeId: string, propertyId: string, isFreeHold?: string, isWallet?: string }> {

}

class OwnerEjariServices extends Component<Props> {
	render() {
		const pp = this.props.match.url;
		const loader = ( this.props.match.params.isWallet === "true" ) ? EjariPropertyLoader : TabuPropertyLoader;
		return <EjariContextWrapper extraContext={ { userType: "owner" } } loader={ loader }>
			<Switch>
				<Route path={ [ pp + "/details" ] } component={ PropertyDetails }/>
				<Route path={ [ pp + "/edit" ] } component={ PropertyEdit }/>
				<Route path={ [ pp + "/cooccupants" ] } component={ EjariPropertyCoOccupants }/>
				<Route path={ pp + "" } exact={ true }>
					<Redirect to={ pp + "/details" }/>
				</Route>
			</Switch>
		</EjariContextWrapper>;
	}
}

export default OwnerEjariServices;
